/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetBankAccountFieldsByCountryCodeResponse,
  UtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeParams,
  SearchBankSwiftResponse,
  UtxBankAccountSearchBankSwiftParams,
  GetBankAccountsResponse,
  DeleteBankAccountResponse,
  PostBankAccountUserDataResponse,
  PostSubmitBankAccountDataRequest
} from './schema'



/**
 * get adding a new bank account's requirement by 2 letters country code
 */
export const utxBankAccountGetBankAccountsRequiredFieldsByCountryCode = (
    params: UtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBankAccountFieldsByCountryCodeResponse>> => {
    return axios.get(
      `/bank-account/requirements`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeQueryKey = (params: UtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeParams,) => [`/bank-account/requirements`, ...(params ? [params]: [])];

    
export type UtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeQueryResult = NonNullable<Awaited<ReturnType<typeof utxBankAccountGetBankAccountsRequiredFieldsByCountryCode>>>
export type UtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeQueryError = AxiosError<unknown>

export const useUtxBankAccountGetBankAccountsRequiredFieldsByCountryCode = <TData = Awaited<ReturnType<typeof utxBankAccountGetBankAccountsRequiredFieldsByCountryCode>>, TError = AxiosError<unknown>>(
 params: UtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBankAccountGetBankAccountsRequiredFieldsByCountryCode>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBankAccountGetBankAccountsRequiredFieldsByCountryCodeQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBankAccountGetBankAccountsRequiredFieldsByCountryCode>>> = ({ signal }) => utxBankAccountGetBankAccountsRequiredFieldsByCountryCode(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBankAccountGetBankAccountsRequiredFieldsByCountryCode>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBankAccountSearchBankSwift = (
    params: UtxBankAccountSearchBankSwiftParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SearchBankSwiftResponse>> => {
    return axios.get(
      `/bank-account/search-bank-swift`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxBankAccountSearchBankSwiftQueryKey = (params: UtxBankAccountSearchBankSwiftParams,) => [`/bank-account/search-bank-swift`, ...(params ? [params]: [])];

    
export type UtxBankAccountSearchBankSwiftQueryResult = NonNullable<Awaited<ReturnType<typeof utxBankAccountSearchBankSwift>>>
export type UtxBankAccountSearchBankSwiftQueryError = AxiosError<unknown>

export const useUtxBankAccountSearchBankSwift = <TData = Awaited<ReturnType<typeof utxBankAccountSearchBankSwift>>, TError = AxiosError<unknown>>(
 params: UtxBankAccountSearchBankSwiftParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBankAccountSearchBankSwift>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBankAccountSearchBankSwiftQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBankAccountSearchBankSwift>>> = ({ signal }) => utxBankAccountSearchBankSwift(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBankAccountSearchBankSwift>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBankAccountGetBankAccounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBankAccountsResponse[]>> => {
    return axios.get(
      `/bank-account`,options
    );
  }


export const getUtxBankAccountGetBankAccountsQueryKey = () => [`/bank-account`];

    
export type UtxBankAccountGetBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxBankAccountGetBankAccounts>>>
export type UtxBankAccountGetBankAccountsQueryError = AxiosError<unknown>

export const useUtxBankAccountGetBankAccounts = <TData = Awaited<ReturnType<typeof utxBankAccountGetBankAccounts>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxBankAccountGetBankAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxBankAccountGetBankAccountsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxBankAccountGetBankAccounts>>> = ({ signal }) => utxBankAccountGetBankAccounts({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxBankAccountGetBankAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxBankAccountDeleteBankAccount = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DeleteBankAccountResponse>> => {
    return axios.delete(
      `/bank-account/${id}`,options
    );
  }



    export type UtxBankAccountDeleteBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxBankAccountDeleteBankAccount>>>
    
    export type UtxBankAccountDeleteBankAccountMutationError = AxiosError<unknown>

    export const useUtxBankAccountDeleteBankAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBankAccountDeleteBankAccount>>, TError,{id: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBankAccountDeleteBankAccount>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  utxBankAccountDeleteBankAccount(id,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBankAccountDeleteBankAccount>>, TError, {id: string}, TContext>(mutationFn, mutationOptions)
    }
    export const utxBankAccountPostBankAccount = (
    postSubmitBankAccountDataRequest: PostSubmitBankAccountDataRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostBankAccountUserDataResponse>> => {
    return axios.post(
      `/bank-account/submit`,
      postSubmitBankAccountDataRequest,options
    );
  }



    export type UtxBankAccountPostBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxBankAccountPostBankAccount>>>
    export type UtxBankAccountPostBankAccountMutationBody = PostSubmitBankAccountDataRequest
    export type UtxBankAccountPostBankAccountMutationError = AxiosError<unknown>

    export const useUtxBankAccountPostBankAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxBankAccountPostBankAccount>>, TError,{data: PostSubmitBankAccountDataRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxBankAccountPostBankAccount>>, {data: PostSubmitBankAccountDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxBankAccountPostBankAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxBankAccountPostBankAccount>>, TError, {data: PostSubmitBankAccountDataRequest}, TContext>(mutationFn, mutationOptions)
    }
    